/**
 * URL Helper Utility
 * Normalizes PUBLIC_URL by removing /template/cryptoon/react path
 */

/**
 * Get normalized base URL
 * Removes /template/cryptoon/react from PUBLIC_URL if present
 * @returns {string} Normalized base URL (empty string for root)
 */
export const getBaseUrl = () => {
  const publicUrl = process.env.PUBLIC_URL || '';
  // Remove /template/cryptoon/react if present, remove trailing slash
  return publicUrl.replace(/\/template\/cryptoon\/react\/?/g, '').replace(/\/$/, '') || '';
};

/**
 * Build a path with normalized base URL
 * @param {string} path - The path to append (should start with /)
 * @returns {string} Full path with normalized base URL
 */
export const buildPath = (path) => {
  const baseUrl = getBaseUrl();
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return baseUrl ? `${baseUrl}${cleanPath}` : cleanPath;
};
